<template>
  <v-hover v-slot="{ hover }">
    <v-card
      :elevation="hover ? 12 : 2"
      class="car-brand-card mx-auto"
      max-width="344"
      outlined
      hover
      @click="$emit('edit-location', id)"
    >
      <v-list-item two-line class="mt-3">
        <v-list-item-content>
          <v-list-item-title class="mb-1">
            {{ locationName }}
          </v-list-item-title>
          <v-list-item-subtitle class="last-modified d-flex mt-1">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" x-small>{{ icons.mdiCalendarBlankOutline }}</v-icon>
              </template>
              <span>Last Modified</span>
            </v-tooltip>
            <div class="ml-1">{{ updatedOn }}</div>
          </v-list-item-subtitle>
        </v-list-item-content>

      </v-list-item>
      <div>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon class="status-icon" x-small v-bind="attrs" v-on="on" :color="isActive ? 'success' : 'error'">{{ icons.mdiCircle }}</v-icon>
          </template>
          <span>{{ isActive ? 'Active' : 'Inactive' }}</span>
        </v-tooltip>
        <div class="">
          <v-chip
          class="ma-2 v-chip-light-bg primary--text type-icon"
          color="primary"
          small
          v-if="isPopular"
          >
            Popular
          </v-chip>
          <v-icon class="ml-2 edit-icon" small>{{ icons.mdiPencil }}</v-icon>
        </div>
      </div>
    </v-card>
  </v-hover>
</template>

<script>
import { mdiCircle, mdiPencil, mdiBookmark, mdiCheck, mdiCalendarBlankOutline } from '@mdi/js'

export default {
  components: {},
  props: {
    id: {
      type: String,
      required: true,
    },
    locationName: {
      type: String,
      required: true,
    },
    updatedOn: {
      type: String,
      required: true,
    },
    isActive: {
      type: Boolean,
      required: true,
    },
    isPopular: {
      type: Boolean,
      required: true,
    },
  },
  setup(props) {
    return {
      icons: {
        mdiCircle,
        mdiPencil,
        mdiBookmark,
        mdiCheck,
        mdiCalendarBlankOutline,
      },
    }
  },
}
</script>

<style scoped lang="scss">
.car-brand-card {
  .status-icon {
    position: absolute;
    cursor: pointer;
    left: 10px;
    top: 5px;
  }

  .edit-icon {
    position: absolute;
    cursor: pointer;
    right: 10px;
    top: 7px;
    color: rgb(88, 88, 88);
  }

  .type-icon {
    position: absolute;
    cursor: pointer;
    right: 25px;
    top: -2px;
  }

  .last-modified {
    font-size: 0.7rem;
  }
}
</style>
